import Link from './Link'

export default Link



// WEBPACK FOOTER //
// ./src/components/Link/index.js